import React from 'react';
import { SvgIcon } from '../SvgIcon/SvgIcon.esm.js';

const SensorIcon = ({ ...props }) => {
    return (React.createElement(SvgIcon, { ...props, viewBox: "0 0 14 14" },
        React.createElement("path", { d: "M13.5 14H0.5C0.22386 14 0 13.7761 0 13.5V0.5C0 0.22386 0.22386 0 0.5 0H13.5C13.7761 0 14 0.22386 14 0.5V13.5C14 13.7761 13.7761 14 13.5 14ZM3.75 5.5V2.5C3.75 2.22386 3.52614 2 3.25 2H2.75C2.47386 2 2.25 2.22386 2.25 2.5V5.5C2.25 5.77614 2.47386 6 2.75 6H3.25C3.52614 6 3.75 5.77614 3.75 5.5ZM6.75 5.5V2.5C6.75 2.22386 6.52614 2 6.25 2H5.75C5.47386 2 5.25 2.22386 5.25 2.5V5.5C5.25 5.77614 5.47386 6 5.75 6H6.25C6.52614 6 6.75 5.77614 6.75 5.5ZM9.75 5.5V2.5C9.75 2.22386 9.52614 2 9.25 2H8.75C8.47386 2 8.25 2.22386 8.25 2.5V5.5C8.25 5.77614 8.47386 6 8.75 6H9.25C9.52614 6 9.75 5.77614 9.75 5.5Z" })));
};

export { SensorIcon };
//# sourceMappingURL=SensorIcon.esm.js.map
